var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#076EB2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.25,
    cy: 9,
    r: 9,
    fill: "#076EB2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23535 11.2558C5.0791 11.0931 5.00098 10.88 5.00098 10.6666C5.00098 10.4532 5.0791 10.2402 5.23535 10.0774L8.43534 6.74414C8.74749 6.41862 9.25443 6.41862 9.56662 6.74414L12.7666 10.0774C13.0791 10.403 13.0791 10.9303 12.7666 11.2559C12.4545 11.5814 11.9475 11.5814 11.6353 11.2559L9.00093 8.51172L6.36663 11.2558C6.05448 11.5813 5.54754 11.5813 5.23535 11.2558Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.9cec6a2770f619030fc5ecdedfdb5888.svg";
export { ForwardRef as ReactComponent };